module.exports = __webpack_public_path__ + "static/media/13.954f4003.png";